import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { retry, catchError, map, shareReplay } from "rxjs/operators";
import { environment } from "@environments/environment";
import { Loan, Invoice } from "@app/models";
import { AuthenticationService } from "./authentication.service";

@Injectable({ providedIn: "root" })

export class LoansService {
  columnsMca: any[] = [
    {
      title: "N° de Contrato",
      data: "contract.contract_number",
      className: "like-link",
    },
    {
      title: "Fecha Desembolso",
      data: "contract.disbursement_date",
    },
    {
      title: "Estatus",
      data: "contract.status",
    },
    {
      title: "Monto Desembolsado",
      data: "contract.amount_preaproved",
      price_format: true,
    },
    {
      title: "Monto a Pagar (Payback)",
      data: "balance.payback",
      price_format: true,
    },
    {
      title: "Monto Pagado",
      data: "balance.payment_amount",
      price_format: true,
    },
    {
      title: "Monto Pendiente",
      data: "balance.outstanding_amount",
      price_format: true,
    },
    {
      title: "Fecha de Reporte",
      data: "balance.update_date",
    },
  ];
  private loansCache$: Observable<any> = null;
  private loansCacheKey: string = null;

  constructor(
    private http: HttpClient,
    private authService: AuthenticationService
  ) { }

  getLoans(mrpId: any, partnerCode: any, itemsPerPage:any) {
    const cacheKey = `${mrpId}_${partnerCode}_${itemsPerPage}`;
    if (this.loansCache$ && this.loansCacheKey === cacheKey) {
      return this.loansCache$;
    }
    let url = `${environment.scs_url_lh}/portal/get_loans?mrp_id=${mrpId}&code=${partnerCode}&limit=${itemsPerPage}`;
    this.loansCacheKey = cacheKey;
    this.loansCache$ = this.http.get<any>(url).pipe(
      map(res => res),
      shareReplay(1)
    );
    return this.loansCache$;
  }

  clearLoansCache() {
    this.loansCache$ = null;
    this.loansCacheKey = null;
  }

  getLoan(loanId, mrpId, partnerCode) {
    let url = `${environment.scs_url_lh}/portal/loans/${loanId}/${partnerCode}?&mrp_id=${mrpId}`;
    return this.http.get<any>(url)
      .pipe(map(res => {
        return res;
      }));
  }

  getPaymentList(period, loanId) {
    const data = {
      access_token: this.authService.currentUserValue.scs_access_token,
      period: period,
      idContract: loanId,
      partner_id: this.authService.currentUserValue.partner_id,
    };
    return this.http
      .post<Invoice[]>(`${environment.scs_url}/loans/payments`, data)
      .pipe(
        map((payments) => {
          return payments;
        })
      );
  }

  getAccounts(account_id: any) {
    const data = {
      access_token: this.authService.currentUserValue.scs_access_token,
      account_id:
        account_id != null ? account_id : this.authService.currentUserValue.id,
      partner_id: this.authService.currentUserValue.partner_id,
    };
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.authService.currentUserValue}`,
    });
    let options = { headers: headers };
    return this.http
      .post<any>(
        environment.scs_url + "/loans/get/accounts",
        JSON.stringify(data),
        options
      )
      .pipe(retry(1), catchError(this.errorHandl));
  }

  getPatnerCode(id): Observable<any> {
    let url = `${environment.scs_url_lh}/portal/${id}/partner_code`;
    return this.http.get<any>(url)
      .pipe(map(res => {
        return res;
      }))
  }

  getProviderStyles(partner_code) {
    let url = `${environment.scs_url_lh}/mca_no_auth/${partner_code}/provider_configurations`;
    return this.http.get<any>(url)
      .pipe(map((res: any) => {
        return res.data;
      }))
  }

  // Error handling
  errorHandl(error: any) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }

  getColumnsByProvider(partner_id) {
    if (partner_id) {
      return this.columnsMca
    }
  }

  getOppsByCreditLine(limit:any, offset:any, creditLineId:any){
    let url = `${environment.scs_url_lh}/portal/get_opps_by_credit_line_portal?limit=${limit}&offset=${offset}&credit_line_id=${creditLineId}`;
    return this.http.get<any>(url)
      .pipe(map(res => {
        return res;
      }));
  }
}
